import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearFormInput, formInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import CheckInput from 'screens/components/basic/CheckInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import ListCheckbox from 'screens/components/basic/ListCheckbox';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Pending",
        value: "1"
    },
    {
        text: "Approved",
        value: "2"
    },
    {
        text: "Disapproved",
        value: "3"
    }
];

const pageName = "shiftList";

class SearchFields extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.employeeOptions,
            selectStatus: false
        }
        this.clearInput = this.clearInput.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.resetState = this.resetState.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        nextProps.employeeOptions.sort((a, b) => {
            const nameA = a.text.toUpperCase().trim();
            const nameB = b.text.toUpperCase().trim();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        }
        );
        this.setState({ data: nextProps.employeeOptions });

        if (this.props.isShowList !== nextProps.isShowList && nextProps.isShowList === false){
            this.clearInput()
        }
    }

    clearInput() {
        this.setState({
            selectStatus: "clear"
        }, () => this.props.clearFormInput(`shiftListEmployeeList`)
        );
    }

    selectAll() {
        var allIds = [];
        const myData = this.state.data;
        myData.map((item, index) => {
            allIds.push(item.value);
        });

        this.setState({
            selectStatus: "all"
        }, () => this.props.formInput(allIds, `shiftListEmployeeList`)
        );
    }

    resetState() {
        this.setState({
            selectStatus: false
        });
    }

    render() {
        return (
            <div className="row m-0">
                {/*Search Inputs*/}
                <div className="row m-0">
                    <div className="col-sm-4">
                        <TextInput
                            name={`${pageName}FirstNameFilter`}
                            className="search-field"
                            label={LOOKUP.shiftList.filters.firstName.label}
                            floatingLabelText={LOOKUP.shiftList.filters.firstName.label}
                            hintText={LOOKUP.shiftList.filters.firstName.hintText}
                            maxLength={20}
                            onPressKey={this.props.search} />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            name={`${pageName}LastNameFilter`}
                            className="search-field"
                            label={LOOKUP.shiftList.filters.lastName.label}
                            floatingLabelText={LOOKUP.shiftList.filters.lastName.label}
                            hintText={LOOKUP.shiftList.filters.lastName.hintText}
                            maxLength={20}
                            onPressKey={this.props.search} />
                    </div>
                    <div className="col-sm-4">
                        <DatePickerInput name={`${pageName}BeginDateFilter`}
                            className="search-field"
                            label={LOOKUP.shiftList.filters.beginDate.label}
                            floatingLabelText={LOOKUP.shiftList.filters.beginDate.label}
                            hintText={LOOKUP.shiftList.filters.beginDate.hintText}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DatePickerInput name={`${pageName}EndDateFilter`}
                            className="search-field"
                            label={LOOKUP.shiftList.filters.endDate.label}
                            floatingLabelText={LOOKUP.shiftList.filters.endDate.label}
                            hintText={LOOKUP.shiftList.filters.endDate.hintText}
                        />
                    </div>
                    <div className="col-sm-4">
                        <SelectInput
                            name={`${pageName}Status`}
                            className="search-field"
                            label="Status"
                            floatingLabelText="Status"
                            defaultValue="None"
                            options={statusOptions} />
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col-sm-4">
                        <CheckInput
                            name={`${pageName}ShowEmployees`}
                            text="Show Employee Filter"
                        />
                    </div>
                </div>
                <div className="row m-0 search-buttons">
                    <div className="col-lg-8">
                        <p className="purpleText font-italic">
                            <b>Note: </b>If an employee has access to multiple branch, all timesheets will contain this employee.
                        </p>
                    </div>
                    <div className="col-lg-4 text-right">
                        <Button
                            type="IconSearchButton"
                            mini={true}
                            label={LOOKUP.shiftList.filters.filterButton}
                            onTouchTap={this.props.search}
                            className="mr-2"
                        />
                        <Button
                            type="IconClearButton"
                            label={LOOKUP.shiftList.filters.cleanFilterButton}
                            onTouchTap={this.props.cleanSearch}
                        />
                    </div>
                </div>
                {/* Show list of employee after the branch is selected */}
                {
                    this.props.isShowList ?
                        <div className="row m-0">
                            <h3 className="text-center">List of Employees</h3>
                            <div className="text-center">
                                <Button
                                    type="FlatButtonPrimary"
                                    label="Select All"
                                    secondary={false}
                                    //TODO: Add function to select all employees
                                    onTouchTap={this.selectAll}
                                />
                                <Button
                                    type="FlatButtonPrimary"
                                    label="Deselect All"
                                    //TODO: Add function to deselect all employees
                                    onTouchTap={this.clearInput}
                                />
                            </div>
                            <ListCheckbox
                                name={pageName + "EmployeeList"}
                                selectStatus={this.state.selectStatus}
                                callBack={this.resetState}
                                collection={this.state.data}
                            />
                        </div>
                        :
                        ""
                }{/* .col EMPLOYEES */}
            </div>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions
    }
}

const mapDispatchToProps = dispatch => {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFields);